<template>
  <div style="margin-top: 10px">
    <div class="row" style="text-align:center">
      <div class="col-md-12">
        <label>{{clientFullName}}</label>
      </div>      
    </div>
    <div class="row">
      <div class="col-md-12">
        <money-with-indicator v-model="model.Importe" v-on:blur="change" v-on:validatedOK="onSaldoOK"/>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from '@/helpers/notificationHelpers';
import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

export default {
    components: {
        "money-with-indicator": MoneyWithIndicator
    },
    props: {
        model: {
            Aux1: "",
            Aux2: "",
            Aux3: "",
            Aux4: "",
            Importe: 0,
            Validate: false,
            Errors: []
        }
    },
    data() {
        return { 
            clientFullName: "", 
            validated: false 
        };
    },
    methods: {
        change(element) {
            this.validate();
            this.$emit("input", this.model);
        },
        validateUser() {
            let context = this;
            axiosHelpers.axiosPost(
                "Article/ValidateHipodromoUser",
                {},
                this,
                function(data) {
                    context.validated = false;

                    if(data.Alerts.length == 0)
                    {
                        if (data.ResponseVM.IsSuccess) {
                            context.model.Aux1 = data.ResponseVM.CUIT_CUIL.trim();
                            context.clientFullName = data.ResponseVM.ClientFullName.trim();
                            context.validated = true;
                        } else if (data.ResponseVM.IsUnexistUser) {
                            context.clientFullName = "El usuario no existe para el producto seleccionado";
                        } else {                            
                            notificationHelpers.showError('Alerta!', 'Ha ocurrido un error al validar el usuario', context);
                        }
                    }

                    context.validate();
                    context.$emit("input", context.model);
                }
            );
        },
        validate() {
            let context = this;
            context.model.Errors = [];

            if (context.model.Aux1.length == 0 || !context.validated) {
                context.model.Validate = false;
                context.model.Errors.push("El usuario no ha sido validado");
            } else if (context.model.Importe <= 0) {
                context.model.Validate = false;
                context.model.Errors.push("El importe no puede ser menor que 0");
            } else {
                context.model.Validate = true;
            }
        },
        onSaldoOK(val) {
            this.$emit("saldoOK", val);
        }
    },
    beforeMount: function() {
        let context = this;
        context.clientFullName = "";
        context.validated = false;
        context.validateUser();
    }
}
</script>